<template>
    <kt-panel>
        <div class="create-services">
            <div class="mx-3">
              <button @click.prevent="showModal" class="btn btn-success">افزودن فیلد دلخواه</button>
            </div>
            <router-link to="/customer-formats" class="mr-2">
                <button class="btn btn-success">بازگشت</button>
            </router-link>
        </div>
        <CreateFieldModal @addField="addField" />
        <form
            @submit.prevent="submitFormat"
            id="single-request-form-customer"
            class="kt-form p-4 my-4 border in-border-header"
        >
          <div class="section-header">ایجاد قالب</div>

          <kt-col
              class="d-flex align-items-center justify-content-between"
              lg="12"
              md="12"
              xs="12"
          >
            <kt-form-group>
              <div>
                <div class="d-block">
                    <span
                        class="d-flex align-items-center my-1 bg-white text-dark"
                        id="basic-addon1"
                    >نام قالب
                      <span class="text-danger">*</span>
                    </span>
                </div>
                <input
                    type="text"
                    class="form-control"
                    id="format_name"
                    name="format_name"
                    aria-describedby="basic-addon1"
                    v-model="format_name"
                />
              </div>
            </kt-form-group>
          </kt-col>
          <div class="d-flex flex-wrap justify-content-between">
            <CustomerFormatField
                class="my-3 col-lg-6 col-md-6 col-12"
                v-for="field in fields"
                :key="field.id"
                :field="field"
                @remove-field="removeField"
                @field-status-changed="handleFieldStatusChanged"
            />
          </div>
          <button class="btn btn-success mt-3">{{$t('btn.save')}}</button>
        </form>
    </kt-panel>
</template>

<script>
import $ from 'jquery';
import toastr from 'toastr';
import { KTApp } from '@/plugins/core/app';
import { i18n } from '@/plugins/i18n';
import { onlineFactorService } from '@/common/shop.service';
import CustomerFormatField from '@/views/online-factor/components/CustomerFormatField.vue';
import CreateFieldModal from './CreateFieldModal.vue';
import { fieldOptions } from '@/constants/CustomerFormatFieldsOptions';

export default {
    components: { CreateFieldModal, CustomerFormatField },
    props: {},
    data() {
        return {
          fields: [],
          format_name: '',
          errors: {
            format_name: null
          }
        };
    },
    computed: {
        toastr() {
            toastr.options = {
                closeButton: true,
                positionClass: 'toast-bottom-center',
                preventDuplicates: true,
                rtl: false
            };

            return toastr;
        }
    },
    mounted() {
        onlineFactorService.fetchFields()
            .then(response => {
              this.fields = response.data.data.data;
            }).catch(error => {
                this.toastr.error(error.data.message)
        })
    },
    methods: {
      removeField(field_id) {
        if (window.confirm('آیا می خواهید این فیلد به طور کلی حذف شود؟')) {
          onlineFactorService.deleteField(field_id)
              .then(response => {
                this.toastr.success(response.data.message)
                this.fields = this.fields.filter(item => item.id !== field_id)
              })
              .catch(({ response }) => {
                this.toastr.error(response.data.message)
              })
        } else {
          this.fields = this.fields.filter(item => item.id !== field_id)
        }
      },
      handleFieldStatusChanged(field) {
        this.fields.find(item => item.id === field.id).status = field.status
      },
      addField(custom_field) {
        if (
            this.fields.some(item => item.name === custom_field.name)
            || this.fields.some(item => item.fa_name === custom_field.fa_name)
        ) {
          $('#add_custom_field').modal('hide')
          return this.toastr.error('فیلد با این نام و یا نام انگلیسی در قالب شما وجود دارد!')
        }

        custom_field.id = this.fields.length + 1
        this.fields.push(custom_field)
        $('#add_custom_field').modal('hide')
      },
      showModal() {
        $('#add_custom_field').modal('show')
      },
      submitFormat(e) {
        let form = $(e.target)
        let btn = $('#form-btn');

        form.validate({
          rules: {
            format_name: {
              required: true,
              minlength: 3,
            }
          }
        })

        if (!form.valid()) {
          return;
        }


        KTApp.progress(btn);
        const data = {
            fields: this.fields.map(field => ({
              ...field,
              id: String(field.id)
            })),
            name: this.format_name,
        }
        // console.log(this.fields, data.fields);
        // return;
        onlineFactorService.submitCustomerFormat(data)
          .then((response) => {
            this.toastr.success(response.data.message);
            this.$router.push({ path: '/customer-formats' })
          })
          .catch(({ response }) => {
            this.toastr.error(response.data.message);
            for (let err in response.data.data) {
              this.toastr.error(response.data.data[err][0]);
            }
          }).finally(() => {
            KTApp.unprogress(btn);
          })
        }
    }
};
</script>
<style scoped>
.preview_img {
    max-width: 70px;
    max-height: 70px;
    position: absolute;
    top: 10px;
    left: 80px;
}

.create-services {
    display: flex;
    flex-direction: row;
    align-items: flex-start;
    justify-content: flex-end;
}
</style>